const navMenuStorage = {
  state: {
    navMenuItemData: localStorage.getItem('navmenuItem') || null,
    rolePermissions: JSON.parse(localStorage.getItem('role_permission'))

  },
  mutations: {
    SET_NAV_MENU_ITEM_MUTATION:(state, payload) => {
      state.navMenuItemData = JSON.stringify(payload)
    },
    SET_NAV_MENU_ROLE_MUTATION:(state, payload) => {
      state.rolePermissions = payload
    }

  },
  actions: {
    SET_NAVMENU_ITEM:({commit}, payload) => {
      localStorage.setItem('navmenuItem', JSON.stringify(payload))

      commit('SET_NAV_MENU_ITEM_MUTATION', payload)
    },
    SET_ROLE_PERMISSION:({commit}, payload) => {

      
      localStorage.setItem('role_permission', JSON.stringify(payload))

      commit('SET_NAV_MENU_ROLE_MUTATION', payload)

    }
  },
  getters: {
   
    get_navmenu_item_data (state) {
      
      if (state === null) {
        return []
      }
      return JSON.parse(state.navMenuItemData)
    },
    get_role_permission (state) {
      console.log(state)
      // const role_permission = JSON.parse(localStorage.getItem('role_permission')) || null
      return state.rolePermissions
    }
  }
}

export default navMenuStorage
